const STORAGE_KEY = "rh_preview_customers";

export function generateAccessToken() {
  return Array.from(crypto.getRandomValues(new Uint8Array(16)))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

export function loadPreviewCustomers(fallback = []) {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.length) return parsed;
    }
  } catch {
    // ignore corrupt storage
  }
  return fallback;
}

export function savePreviewCustomers(customers) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(customers));
}

export function findPreviewCustomerByToken(token) {
  if (!token) return null;
  return loadPreviewCustomers().find((c) => c.accessToken === token) || null;
}

export function findPreviewCustomerByEmail(email) {
  const normalized = (email || "").trim().toLowerCase();
  if (!normalized) return null;
  return loadPreviewCustomers().find((c) => (c.email || "").toLowerCase() === normalized) || null;
}

export function customerPortalPath(accessToken) {
  return `/customer/${accessToken}`;
}

export function customerPortalUrl(accessToken) {
  return `${window.location.origin}${customerPortalPath(accessToken)}`;
}
